import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const FEE_TYPES = {
  BASE_FEE: 'base_fee',
  SELECT_FEE: 'select_fee',
  EXPENSE_FEE: 'expense_fee',
  EXPEDITE_FEE: 'expedite_fee',
  CANCELLATION_FEE: 'cancellation'
};

const BUYER_FEES = {
  [FEE_TYPES.BASE_FEE] : 'buyerBaseFee',
  [FEE_TYPES.SELECT_FEE] : 'buyerSelectFee',
  [FEE_TYPES.EXPENSE_FEE] : 'buyerExpenseFee',
  [FEE_TYPES.EXPEDITE_FEE] : 'buyerAdvanceFee',
  [FEE_TYPES.CANCELLATION_FEE] : 'buyerCancellationFee',
};

const SELLER_FEES = {
  [FEE_TYPES.BASE_FEE] : 'sellerBaseFee',
  [FEE_TYPES.SELECT_FEE] : 'sellerSelectFee',
  [FEE_TYPES.EXPENSE_FEE] : 'sellerExpenseFee',
  [FEE_TYPES.EXPEDITE_FEE] : 'sellerAdvanceFee',
  [FEE_TYPES.CANCELLATION_FEE] : 'sellerCancellationFee',
};

export const FEE_STRUCTURE = {
  FEE_TYPES,
  BUYER_FEES,
  SELLER_FEES
}

// These are the fees covered when a buyer elects to cover seller fees.
// Please keep these aligned with BUYER_SELLER_FEES_DICTIONARY in FeeStructure.php
export const BUYER_COVER_SELLER_FEE_TYPES = [
  SELLER_FEES[FEE_TYPES.BASE_FEE],
  SELLER_FEES[FEE_TYPES.SELECT_FEE],
  SELLER_FEES[FEE_TYPES.CANCELLATION_FEE],
];

const FeeStructure = ShModel.extend({
  // Misc
  isModified: attr('boolean'),
  isRepeatHire: attr('boolean'),
  isInviteeHire: attr('boolean'),

  // buyer fees
  buyerAdvanceFee: attr('number'),
  buyerBaseFee: attr('number'),
  buyerCancellationFee: attr('number'),
  buyerExpenseFee: attr('number'),
  buyerFlatBaseFee: attr('number'),
  buyerSelectFee: attr('number'),

  // seller fees
  sellerAdvanceFee: attr('number'),
  sellerBaseFee: attr('number'),
  sellerCancellationFee: attr('number'),
  sellerFlatBaseFee: attr('number'),
  sellerExpenseFee: attr('number'),
  sellerSelectFee: attr('number'),

  // relationships
  application: belongsTo('application', { async: false }),
  seller: belongsTo('user', { async: false }),
});

export default FeeStructure;
